// @flow
import React from 'react';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import renderNothing from 'recompose/renderNothing';
import branch from 'recompose/branch';
import { Trans } from 'react-i18next';

import Tariff from 'app/components/Tariff';
import type { TariffType } from 'app/components/Tariff/Tariff';
import { TARIFF_EXTERNAL_SYSTEM } from 'app/common/constants/tariffs';

import enhanceTariffsList, { type CurrentTariffInfo } from './enhanceTariffsList';


type SubscribedTariffProps = {
  tariffs: Array<TariffType>,
  currentTariffInfo: CurrentTariffInfo,
}
// текущий подписанный тариф
const SubscribedTariff = compose(
  mapProps(({ tariffs, currentTariffInfo, ...other }: SubscribedTariffProps) => {
    const foundedTarif = tariffs.find(({ id, inside, kind }) => {
      if (currentTariffInfo.bundleId) {
        return !!inside && id === currentTariffInfo.bundleId;
      }
      if (currentTariffInfo.kind === TARIFF_EXTERNAL_SYSTEM) {
        return kind === TARIFF_EXTERNAL_SYSTEM;
      }
      return id === currentTariffInfo.tariffId;
    });

    return {
      ...other,
      tariff: foundedTarif,
    };
  }),
  branch(({ tariff }) => !tariff, renderNothing)
)(Tariff);

/**
* Список тарифов
*/
type Props = {
  tariffs: Array<TariffType>,
  currentTariffInfo: CurrentTariffInfo,
  currentSubId?: number,
  studentId: number,
  service: string,
  close: (e: SyntheticEvent<HTMLElement>) => void,
  t: (x: string, y: Object) => string,
};

const TariffsList = ({ tariffs, currentTariffInfo, currentSubId, studentId, service, close, t }: Props) => (
  (tariffs && tariffs.length)
    ? <div>
      {currentSubId
        && <SubscribedTariff
          tariffs={tariffs}
          currentTariffInfo={currentTariffInfo}
          subId={currentSubId}
          studentId={studentId}
          service={service}
          close={close}
        />}

      {tariffs
        .filter(tariff => !currentTariffInfo.isTariffPartOf(tariff))
        .map(tariff =>
          <Tariff
            key={tariff.key}
            tariff={tariff}
            studentId={studentId}
            service={service}
            subscribeText={currentSubId ? t('subs:change_tariff') : t('subs:connect_bt')}
            close={close}
          />)}
    </div>

    : <h1>
      <Trans i18nKey="subs:no_available_tariffs">
        Нет доступных тарифов
      </Trans>
    </h1>
);

export default enhanceTariffsList(TariffsList);
